module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outofStockModal"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('outOfStock')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "message raleway",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('outOfStockText'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "articles"
  }, _vm._l((_vm.stockArticles), function(article) {
    return (_vm.stockArticles) ? _c('div', {
      staticClass: "article"
    }, [_c('div', {
      staticClass: "image"
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('img', {
      attrs: {
        "src": _vm.getArticleImage(article)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "button small watch",
      on: {
        "click": function($event) {
          _vm.watchProduct(article)
        }
      }
    }, [_vm._v(" Bevaka ")])]) : _vm._e()
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fef5f446!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Modals/Content/NoStock.vue
// module id = 176
// module chunks = 0